import WebHttpClient from '~src/httpClient/WebHttpClient';
import { GetPrivateConnectionsRequest, IGetPrivateConnectionsResult } from '~src/settings/privateconnect-settings/serverApi/requests/GetPrivateConnectionsRequest';

export function getPrivateConnections(): Promise<IGetPrivateConnectionsResult>  {
    return WebHttpClient.sendRequest(new GetPrivateConnectionsRequest({}));
  }

export const PrivateConnectService = {
  getPrivateConnections: getPrivateConnections
};